var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-body" },
    [
      _c("page-banner", _vm._b({}, "page-banner", _vm.page.banner, false)),
      _c(
        "page-limiter",
        [
          _vm.crumbs && _vm.crumbs.length
            ? _c("breadcrumbs", { attrs: { crumbs: _vm.crumbs } })
            : _vm._e(),
          _vm.page.head
            ? _c(
                "section",
                {
                  directives: [
                    { name: "scroll-reveal", rawName: "v-scroll-reveal" }
                  ],
                  staticClass: "making-head"
                },
                [
                  _c("h1", { staticClass: "making-head__sub-title" }, [
                    _vm._v(_vm._s(_vm.page.head.subTitle))
                  ]),
                  _c("h2", { staticClass: "making-head__title" }, [
                    _vm._v(_vm._s(_vm.page.head.title))
                  ]),
                  _c("p", [_vm._v(_vm._s(_vm.page.head.text))]),
                  _vm.toVideo.link
                    ? _c(
                        "btn",
                        {
                          staticClass: "btn btn--primary btn--has-arrow",
                          attrs: { tag: "link", link: _vm.toVideo.link }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t" +
                              _vm._s(_vm.toVideo.title) +
                              "\n\t\t\t\t"
                          ),
                          _c("icon-arrow", { staticClass: "btn-icon" })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm.page.features && _vm.page.features.length
            ? _c("section", { staticClass: "making-features" }, [
                _c(
                  "ul",
                  { staticClass: "making-features-list" },
                  _vm._l(_vm.page.features, function(item) {
                    return _c(
                      "li",
                      {
                        directives: [
                          { name: "scroll-reveal", rawName: "v-scroll-reveal" }
                        ],
                        staticClass: "making-features-list__item"
                      },
                      [
                        _c("div", {
                          staticClass: "making-features-list__image-box",
                          style: {
                            "background-image": "url(" + item.image + ")"
                          }
                        }),
                        _c(
                          "div",
                          { staticClass: "making-features-list__text-box" },
                          [
                            _c(
                              "h3",
                              { staticClass: "making-features-list__title" },
                              [_vm._v(_vm._s(item.title))]
                            ),
                            _c("p", [_vm._v(_vm._s(item.text))])
                          ]
                        )
                      ]
                    )
                  }),
                  0
                )
              ])
            : _vm._e(),
          _vm.docs.show && _vm.docsList && _vm.docsList.length
            ? _c("section", { staticClass: "making-docs" }, [
                _c("h2", { staticClass: "making-docs__title" }, [
                  _vm._v(_vm._s(_vm.docs.heading))
                ]),
                _c(
                  "ul",
                  { staticClass: "making-docs-list" },
                  _vm._l(_vm.docsList, function(item, index) {
                    return _c(
                      "li",
                      {
                        directives: [
                          {
                            name: "scroll-reveal",
                            rawName: "v-scroll-reveal",
                            value: { delay: 220 + index * 60 },
                            expression: "{delay: 220 + index * 60}"
                          }
                        ],
                        staticClass: "making-docs-list__item"
                      },
                      [
                        item.link
                          ? _c(
                              "a",
                              {
                                staticClass: "making-docs-list__link",
                                attrs: { href: item.link, target: "_blank" }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "making-docs-list__link-icon"
                                  },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        attrs: {
                                          width: "24",
                                          height: "30",
                                          viewBox: "0 0 24 30"
                                        }
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d:
                                              "M23 30H1c-.5 0-1-.4-1-1V1c0-.5.4-1 1-1h22c.5 0 1 .4 1 1v28c0 .6-.4 1-1 1zM2 28h20V2H2v26z"
                                          }
                                        }),
                                        _c("path", {
                                          attrs: {
                                            d:
                                              "M16.9 9.3H7.1c-.5 0-1-.4-1-1s.4-1 1-1H17c.5 0 1 .4 1 1s-.5 1-1.1 1zM12.3 22.7H7.1c-.5 0-1-.4-1-1s.4-1 1-1h5.2c.5 0 1 .4 1 1s-.4 1-1 1zM16.9 16H7.1c-.5 0-1-.4-1-1 0-.5.4-1 1-1H17c.5 0 1 .4 1 1-.1.6-.5 1-1.1 1z"
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass: "making-docs-list__link-name"
                                  },
                                  [_vm._v(_vm._s(item.name))]
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass: "making-docs-list__link-info"
                                  },
                                  [_vm._v(_vm._s(item.info))]
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  }),
                  0
                )
              ])
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7a7768a0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a7768a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/pages/PageMaking.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-7a7768a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/pages/PageMaking.vue
// module chunks = 0